import { ReferenceCitationNode } from '../nodes/ReferenceCitationNode';

// Helper function to recursively remove fields that shouldn't be compared
const removeUncomparableFields = (node: Record<string, unknown>): void => {
  if (!node || typeof node !== 'object') {
    return;
  }

  // Remove fields that change automatically and shouldn't affect hasChanges
  delete node.textStyle;
  delete node.direction;
  delete node.textFormat;

  // Remove text field for reference-citation nodes as it can change dynamically
  if (node.type === ReferenceCitationNode.getType()) {
    delete node.text;
  }

  // Remove extra color fields, keep only essential ones
  if ('color' in node && typeof node.color === 'object' && node.color !== null) {
    const color = node.color as Record<string, unknown>;
    delete color.id;
    delete color.CMYK;
    delete color.RGB;
  }

  if ('children' in node && Array.isArray(node.children)) {
    for (const child of node.children) {
      if (typeof child === 'object' && child !== null) {
        removeUncomparableFields(child as Record<string, unknown>);
      }
    }
  }
};

// Helper function to normalize editor state
export const normalizeEditorState = (stateJson: string): string => {
  try {
    const state = JSON.parse(stateJson) as Record<string, unknown>;

    // Remove uncomparable fields from root and all children
    if ('root' in state && typeof state.root === 'object' && state.root !== null) {
      removeUncomparableFields(state.root as Record<string, unknown>);
    }

    return JSON.stringify(state);
  } catch {
    return stateJson; // Return original if parsing fails
  }
};
